module.exports = __webpack_public_path__ + "img/login.4f8cada5.png";